import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useFeatures } from 'modules/core/hooks/useFeatures'
import i18n from 'modules/core/lib/i18n'

import {
  formatCounterAmount,
  isHourlyFixedBalanceAllowance,
} from 'modules/timeoff/components/Leaves/Overview/formatCounterAmount'

import type Allowance from 'modules/timeoff/store/models/Allowance'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'
import type AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'

import AvailableTooltip from './AvailableTooltip'

interface Props {
  allowance: Allowance
  currentStat: AllowanceStat
  currentCycle: Cycle
  nextCycle: Cycle | null | undefined
}

const AvailableDays = ({ allowance, currentStat, currentCycle, nextCycle }: Props) => {
  const { has_dev_timeoff_new_counter_calculations } = useFeatures([
    'dev_timeoff_new_counter_calculations',
  ])
  const stat = currentStat.toJS()

  let accrued: number
  let advance: number

  if (
    has_dev_timeoff_new_counter_calculations &&
    stat.effective_accrued != null &&
    stat.advance != null
  ) {
    accrued = stat.effective_accrued
    advance = stat.advance
  } else {
    const availableDays = stat.available_days
    accrued = stat.prorated_allowance_days

    if (stat.used_days > accrued) {
      accrued = availableDays > 0 ? availableDays : 0
    }

    advance = availableDays < 0 ? availableDays : 0
  }

  const title = allowance.isDays
    ? i18n.t('time_off.available_tooltip.available_days')
    : i18n.t('time_off.available_tooltip.available_hours')

  return (
    <>
      <Box flexDirection="row" gap="s8" paddingY="s16">
        <Text size="700" weight="medium">
          {formatCounterAmount(stat.available_days, isHourlyFixedBalanceAllowance(allowance))}
        </Text>
        <AvailableTooltip
          accrued={accrued}
          allowance={allowance}
          carryOver={stat.accumulated_carry_over}
          incidence={stat.incidences}
          currentCycle={currentCycle}
          nextCycle={nextCycle}
          advance={advance}
        />
      </Box>
      <Box>
        <Text.Header3>{title}</Text.Header3>
      </Box>
    </>
  )
}

export default observer(AvailableDays)
